(function () {


	angular.module('app.widgets')
    .directive('plaFileSelect', plaFileSelect); 
    
    plaFileSelect.$inject  = ['FileReaderService', '$timeout'];

	function plaFileSelect(FileReaderService, $timeout) {
        return {
            scope: {
              ngModel: '='
            },
            link: function($scope, el) {
              function getFile(file) {
                FileReaderService.readAsDataUrl(file, $scope)
                  .then(function(result) {
                    $timeout(function() {
                      $scope.ngModel = result;
                    });
                  });
              }
      
              el.bind("change", function(e) {
                var file = (e.srcElement || e.target).files[0];
                getFile(file);
              });
            }
          };
    }

})();